import React from "react";
import {
  Spin,
  Upload,
  message,
  Button,
  Form,
  Alert,
  Image,
  Progress,
  Checkbox,
  Flex,
  Collapse,
  Descriptions,
  Popover,
} from "antd";
import {
  CheckOutlined,
  CloudUploadOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
  ReloadOutlined,
  SafetyCertificateOutlined,
  
} from "@ant-design/icons";
import Apiauth from "../../../api/Apiauth";
import {
  DOCTYPerrorMessage,
  getFileSizeInfo,
  openNotification,
} from "../../../utils";
import { CopyTextToClipboard } from "../../../helpers/copy";
import { t } from "i18next";
import ComponentSearch from "./componentSearch";
import { itemsDescriptions } from "../../../components/Slipmate/itemsDescriptions";
import expImg from "../../../assets/images/Screenshot_1.png";
import ImgCrop from "antd-img-crop";
import Swal from "sweetalert2";

const statusFalse = ["NOT_MATCH", "DUPLICATED"];
const MAX_SIZE_MB = 1;

class ComponentVerifySlip extends React.Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      apiResponse: null,
      apiError: null,
      fileList: [],
      previewImage: null,
      uploadProgress: 0,
      customer_uuid: null,
      showContent: false,
      error: null,
      onHiden: false,
      isConfirm: false,
      showAlert: false,
      showCropNote: false,
      showCropAfterError: false,
      onProgress: false, // ใช้ควบคุมการแสดง Progress Bar ด้านล่าง
      showBtnCheck: true,
      uploading: 0,
      sizeImage: 0,
    };
    this.inputRef = React.createRef();
    this.handleFocusAll = this.handleFocusAll.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.onRemove = this.onRemove.bind(this);
  }

  componentDidMount() {
    this.setState({ showContent: false });
  }

  // ไม่ได้ใช้ในโค้ดปัจจุบัน แต่เก็บไว้เผื่ออนาคต
  handleFocusAll() {
    const { customer_uuid } = this.state;
    if (customer_uuid) {
      CopyTextToClipboard(customer_uuid);
    }
    this.inputRef.current.focus({
      cursor: "all",
    });
  }

  handleFileChange = (info) => {
    let newFileList = [...info.fileList];

    newFileList = newFileList.slice(-1);

    const { originFileObj, status, percent } = info.file;
    if (originFileObj) {
      const reader = new FileReader();
      reader.readAsDataURL(originFileObj);
      reader.onload = () => {
        this.setState({ previewImage: reader.result });
      };
      reader.onerror = (error) => {
        console.error("Error reading file:", error);
        openNotification(
          "error",
          t("File Read Error"),
          t("ไม่สามารถอ่านไฟล์รูปภาพได้")
        );
        this.setState({
          previewImage: null,
          fileList: [],
          uploadProgress: 0,
          uploading: 0,
        });
      };
    } else {
      this.setState({ previewImage: null, uploadProgress: 0, uploading: 0 });
    }

    this.setState({ fileList: newFileList }, () => {
      if (newFileList.length === 0) {
        this.setState({
          apiResponse: null,
          apiError: null,
          uploadProgress: 0,
          onHiden: false,
          isConfirm: false,
          txtBtn: "ตรวจสอบ",
          showCropNote: false,
          uploading: 0,
          onProgress: false,
        });
      }
    });

    if (status === "uploading") {
      this.setState({
        uploading: percent || 0,
        onProgress: false,
      });
    } else if (status === "done") {
      this.setState({
        uploading: 100,
        onProgress: true,
      });
      console.log(`${info.file.name} file uploaded successfully.`);
    } else if (status === "error") {
      this.setState({ uploading: 0, onProgress: false });
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  customUploadRequest = ({ file, onSuccess, onError, onProgress }) => {
    const totalTime = 1500;
    const intervals = 3;
    let currentStep = 0;

    const intervalId = setInterval(() => {
      currentStep++;
      const percent = Math.round((currentStep / intervals) * 100);

      onProgress({ percent, loaded: currentStep, total: intervals }, file);

      if (currentStep >= intervals) {
        clearInterval(intervalId);
        onSuccess("ok");
      }
    }, totalTime / intervals);
  };
  beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      Swal.fire({
        title: t("error_occurred"),
        text: t("format_error"),
        icon: "warning",
      });
      return Upload.LIST_IGNORE;
    }

    const fileSizeInMB = file.size / 1024 / 1024;

    const isLt1M = fileSizeInMB < MAX_SIZE_MB;
    let errorMessage = t(`system_size_error`);
    this.setState({ sizeImage: 0 });
    if (!isLt1M) {
      Swal.fire({
        title: t(`size_limit_title`, { maxSize: MAX_SIZE_MB }),
        text: t(`crop_recommendation`),
        icon: "warning",
      });
      this.setState({
        showCropNote: true,
        showCropAfterError: true,
        loading: false,
        fileList: [],
        uploadProgress: 0,
        apiError: errorMessage,
        error: { status: 413, message: errorMessage },
      });
      return Upload.LIST_IGNORE;
    }
    let size = getFileSizeInfo(file);
    this.setState({ sizeImage: size?.kilobytes || 0,  error: null });
    return true;
  };

  onRemove = () => {
    this.setState({
      fileList: [],
      previewImage: null,
      apiResponse: null,
      apiError: null,
      error: null,
      onHiden: false,
      uploadProgress: 0,
      isConfirm: false,
      showAlert: false,
      showCropNote: false,
      onProgress: false,
      uploading: 0,
      showBtnCheck: true,
      sizeImage: 0,
    });
    this.formRef.current.setFieldsValue({ file: [] });
    this.props.handleShowBtnConfirm(false, null); // เรียก prop เพื่อซ่อนปุ่มยืนยัน
    return true;
  };
  onFinish = async () => {
    const { fileList, customer_uuid } = this.state;

    // ตั้งค่าสถานะเริ่มต้นการโหลด
    this.props.handleChangeLoading(true); // Prop สำหรับคอมโพเนนต์ภายนอก
    this.setState({
      loading: true,
      uploadProgress: 0,
      onHiden: false,
      showCropNote: false,
      error: null,
    });

    try {
      if (!customer_uuid) {
        openNotification(
          "error",
          t("An error occurred."),
          t("No Customer UUID information was found.")
        );
        this.setState({ loading: false, uploadProgress: 0 });
        this.props.handleChangeLoading(false);
        return;
      }
      if (fileList.length === 0 || !fileList[0].originFileObj) {
        openNotification("error", t("An error occurred."), t("Please upload the receipt image."));
        this.setState({ loading: false, uploadProgress: 0 });
        this.props.handleChangeLoading(false);
        return;
      }

      // เตรียม FormData สำหรับส่ง API
      const formData = new FormData();
      formData.append("file", fileList[0].originFileObj);
      formData.append("type", "SLIP_VERRIFY");
      formData.append("customerUuid", customer_uuid);

      const response = await Apiauth.getUploadSlip(formData, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          this.setState({ uploadProgress: percentCompleted });
        },
      });

      const data = response?.data;

      if (response.status !== 200) {
        openNotification(
          "error",
          t("Verification failed."),
          t(data?.note) || t("The transaction cannot be completed.")
        );
        this.setState({
          loading: false,
          uploadProgress: 0,
        });
        this.props.handleShowBtnConfirm(false, data);
        this.props.handleChangeLoading(false);
        return;
      }
      if (statusFalse.includes(data?.status)) {
        openNotification("warning", data?.status, data?.note);
        this.setState({
          loading: false,
          apiResponse: response,
          onHiden: true,
          txtBtn: t("ลองอีกครั้ง"),
          uploadProgress: 0,
        });

        this.props.handleChangeLoading(false);
        this.props.handleShowBtnConfirm(false, data);
        return;
      }

      // ตรวจสอบสำเร็จ
      this.props.handleChangeLoading(false);
      this.props.handleShowBtnConfirm(true, data); // บอกคอมโพเนนต์แม่ให้แสดงปุ่มยืนยัน
      this.setState({
        apiResponse: response,
        loading: false,
        onHiden: true, // ซ่อน Upload Dragger เมื่อสำเร็จ
        isConfirm: true, // แสดงปุ่ม Approval ภายใน Collapse
        showContent: true,
        showCropNote: false,
        showCropAfterError: false,
        showBtnCheck: false,
        uploadProgress: 100,
        apiError: null
      });

      openNotification("success", data?.status, "SLIP MATCHED");
    } catch (error) {
      console.error("Error checking slip:", error);

      let errorMessage = t("An error occurred while verifying the item.");
      const status = error.response ? error.response.status : error.status;
      const ERROR_STATUSES = [500, 413];
      if (ERROR_STATUSES.includes(status)) {
        errorMessage = error?.response?.data?.message || error?.message;
        this.setState({
          showCropNote: true,
          showCropAfterError: true,
          loading: false,
          fileList: [],
          uploadProgress: 0,
          error: { status: status, message: errorMessage },
        });
      } else if (error.response) {
        console.error("Error", error);
        if (error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.response.data) {
          errorMessage = DOCTYPerrorMessage(error.response.data);
        } else {
          errorMessage = `Server error: ${error.response.status}`;
        }
        this.setState({ error: error, loading: false, uploadProgress: 0 });
        openNotification("error", t("Verification failed."), errorMessage);
      } else if (error.request) {
        console.error("Error request:", error.request);
        errorMessage = "No response was received from the server. Please try again.";
        this.setState({ error: error, loading: false, uploadProgress: 0 });
        openNotification("error", t("Verification failed."), errorMessage);
      } else {
        console.error("Error message:", error.message);
        errorMessage = error.message;
        this.setState({ error: error, loading: false, uploadProgress: 0 });
        openNotification("error", t("Verification failed."), errorMessage);
      }
      this.setState({
        apiError: errorMessage,
        loading: false,
        uploadProgress: 0,
      });
      this.props.handleChangeLoading(false);
    }
  };

  onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    openNotification("error", t("The information is incorrect."), t("Please check all the information."));
  };

  setDataSearchCustomers = (item) => {
    let { value } = item;
    if (value) {
      this.setState({
        customer_uuid: value,
        showContent: true,
      });
    } else {
      this.setState({
        customer_uuid: null,
        showContent: false,
        showAlert: true,
      });
    }
  };

  render() {
    const {
      loading,
      apiResponse,
      fileList,
      previewImage,
      uploadProgress,
      customer_uuid,
      showContent,
      error,
      onHiden,
      isConfirm,
      showAlert,
      showCropNote,
      uploading,
      showCropAfterError,
      showBtnCheck,
      sizeImage
    } = this.state;
    let { resAllDataMerchang } = this.props;

    const uploadProps = {
      listType: "picture",
      maxCount: 1,
      fileList: fileList,
      customRequest: this.customUploadRequest,
      onChange: this.handleFileChange,
      beforeUpload: this.beforeUpload,
      onRemove: this.onRemove,
      disabled: !customer_uuid || loading || onHiden,
      itemRender: (originNode, file) => {
        if (!file) return null;

        let length = fileList.length;
        let statusDone = file?.status === "done";
        let isCustomRequestUploading = file.status === "uploading";
        let isFileReady = statusDone || file.status === "error";
        let disabled = loading || length < 0 || isConfirm || !statusDone;
        let dNone =
          !isFileReady || isCustomRequestUploading || !showBtnCheck
            ? "d-none"
            : "";
        let ProgressHtml = (
          <Progress type="circle" size={50} percent={uploading} />
        );
        return (
          <>
            <Flex
              justify="space-between"
              align="center"
              style={{
                padding: "8px",
                border: `1px solid ${statusDone ? "#3eacff " : "#ff4d4f"}`,
                margin: 5,
                borderRadius: 8,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {isCustomRequestUploading ? (
                  ProgressHtml
                ) : (
                  <>
                    <Checkbox checked={statusDone} />
                    <Image
                      src={previewImage}
                      alt="Preview"
                      className={`img-fluid img-thumbnail`}
                      style={{
                        width: 50,
                        border: "1px solid #ddd",
                      }}
                      preview={true}
                    />
                  </>
                )}
                <span
                  style={{
                    maxWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    marginRight: 5,
                  }}
                >
                  {sizeImage}KB
                </span>
              </div>
              <Flex gap="small">
                <Button
                  type="primary"
                  size="small"
                  className={`${dNone}`}
                  icon={<SafetyCertificateOutlined />}
                  disabled={disabled}
                  onClick={() => this.formRef.current.submit()}
                >
                  {t("Verify")}
                </Button>
                <Button
                  danger
                  size="small"
                  icon={<DeleteOutlined />}
                  onClick={() => this.onRemove(file)}
                  disabled={loading}
                >
                  {t("Delete")}
                </Button>
              </Flex>
            </Flex>
          </>
        );
      },
    };

    const imgCropProps = {
      showReset: true,
      rotationSlider: true,
      shape: "round",
      modalTitle: (
        <>
          <span className="mb-3" style={{ color: "InfoText" }}>
            {t("crop_instruction")}{" "}
            <Popover
              content={
                <Image
                  src={expImg}
                  alt="Preview"
                  className={`img-fluid img-thumbnail`}
                  style={{
                    width: 150,
                    border: "1px solid #ddd",
                  }}
                  preview={true}
                />
              }
            >
              <InfoCircleOutlined
                style={{ cursor: "pointer", color: "InfoText" }}
              />
            </Popover>
          </span>
          <ul style={{ fontSize: 14 }}>
            <li>{t("drag_instruction")}</li>
            <li>{t("zoom_instruction")}</li>
          </ul>
        </>
      ),
      modalProps: {
        closable: false,
        maskClosable: false,
        width: 600,
      },
    };

    // --- ส่วนแสดงผลลัพธ์ ---
    let res = apiResponse?.data;
    let status = res?.status;
    let note = res?.note;

    let columnProps = {
      xxl: 1,
      xl: 1,
      lg: 1,
      md: 1,
      sm: 1,
      xs: 1,
    };

    // ดึงข้อมูล Descriptions โดยเรียกใช้ฟังก์ชัน itemsDescriptions ที่สร้างไว้ก่อนหน้า
    const descriptionsData = itemsDescriptions({
      resAllDataMerchang: resAllDataMerchang,
      apiResponse: apiResponse,
      previewImage: previewImage,
    });

    // ส่วน Extra ของ Collapse (ปุ่มต่างๆ)
    const genExtra = () => (
      <Flex gap="middle" justify="end" horizontal>
        {isConfirm && (
          <Button
            style={{ fontSize: 13 }}
            type="primary"
            size="small"
            onClick={() => this.props.handleConfirmTransaction(res)}
          >
            <CheckOutlined /> {t("APPROVE")}
          </Button>
        )}
        <Button
          size="small"
          style={{ fontSize: 13 }}
          onClick={() => {
            this.setState({
              fileList: [],
              previewImage: null,
              apiResponse: null,
              apiError: null,
              uploadProgress: 0,
              onHiden: false, // <--- แก้ไข: ให้เป็น false เพื่อแสดง Dragger
              error: null,
              isConfirm: false, // <--- แก้ไข: ตั้งค่า isConfirm เป็น false
            });
            this.formRef.current.resetFields();
            this.props.handleShowBtnConfirm(false, null); // เรียก prop เพื่อซ่อนปุ่มยืนยัน
          }}
          icon={<ReloadOutlined />}
        >
          {t("Reset")}
        </Button>
      </Flex>
    );

    // รายการสำหรับ Collapse
    const itemsCollapse = [
      {
        key: "1",
        label: t("Details"),
        children: (
          <div className="p-1">
            <Descriptions
              bordered
              span={12}
              size="small"
              column={columnProps}
              items={descriptionsData}
            />
          </div>
        ),
        extra: genExtra(),
      },
    ];

    return (
      <>
        <div className="p-1">
          {/* แสดง Alert ผลลัพธ์การตรวจสอบจาก API */}
          {apiResponse && (
            <>
              <Alert
                message={t(status)}
                description={note}
                type={statusFalse.includes(status) ? "warning" : "success"}
                showIcon
                className="mt-3 mb-3"
              />
              <Collapse
                ghost
                items={itemsCollapse}
                defaultActiveKey={["1"]}
                expandIconPosition="start"
              />
            </>
          )}

          {/* แสดง Alert ข้อผิดพลาดทางเทคนิค/เครือข่าย */}
          {error && (
            <Alert
              message={`statusCode: ${error?.status || "Unknown"}`}
              description={
                error?.response?.data?.message ||
                error?.message ||
                "Internal Error"
              }
              type="error"
              showIcon
              className="mt-3 mb-3"
            />
          )}

          <Spin spinning={loading} tip={t("Verifying...")}>
            <Form
              layout="vertical"
              ref={this.formRef}
              variant={"outlined"}
              className="mt-2"
              initialValues={{
                variant: "outlined",
                customer_uuid: customer_uuid,
              }}
              onFinish={this.onFinish}
              onFinishFailed={this.onFinishFailed}
            >
              {/* Form Item: Customer UUID */}
              {showAlert && (
                <Alert
                  className="mb-3"
                  showIcon
                  closable
                  type="error"
                  message={t("*ไม่พบข้อมูล Customer ในระบบ")}
                />
              )}
              <Form.Item
                name="customer_uuid"
                label={t("Customer's")}
                rules={[
                  {
                    required: !customer_uuid,
                    message: t("Please required a Customer UUID!"),
                  },
                ]}
              >
                <ComponentSearch
                  onCustomerSelected={this.setDataSearchCustomers}
                  t={t}
                />
              </Form.Item>

              {/* Form Item: Upload Slip */}
              <Form.Item
                name="file"
                label={t("Upload Slip")}
                // แสดงเมื่อ showContent เป็นจริง
                className={`${showContent ? "animate" : "d-none"}`}
                valuePropName="fileList"
                getValueFromEvent={(e) => {
                  if (Array.isArray(e)) {
                    return e;
                  }
                  return e && e.fileList;
                }}
                rules={[
                  {
                    required: fileList?.length === 0,
                    message: t("Please upload a slip image!"),
                  },
                ]}
              >
                {!showCropAfterError ? (
                  <Upload {...uploadProps}>
                    {/* ปุ่ม Upload จะแสดงก็ต่อเมื่อ onHiden เป็น false (ยังไม่ตรวจสอบสำเร็จ) และไม่มีไฟล์อยู่ใน list */}
                    <Button
                      icon={<CloudUploadOutlined />}
                      disabled={fileList.length > 0}
                      style={{ width: "100%" }}
                      className="mb-1"
                    >
                      {fileList.length > 0
                        ? "File Selected"
                        : t("Click here to upload your slip.")}
                    </Button>
                    {/* ถ้ามีไฟล์อยู่แล้ว จะแสดงเป็น itemRender แทน */}
                  </Upload>
                ) : (
                  <ImgCrop 
                  
                  {...imgCropProps}
                  modalProps={{
                    okText: t("confirm"),
                    cancelText: t("cancel"),
                  }}
                  >
                    <Upload {...uploadProps}>
                      <Button
                        icon={<i className='bx bx-crop' ></i>}
                        disabled={fileList.length > 0}
                        style={{ width: "100%" }}
                        className="mb-3"
                        type="primary"
                      >
                        {fileList.length > 0
                          ? t("File image selected.")
                          : t("Crop image before uploading.")}
                      </Button>
                    </Upload>{" "}
                     
                  </ImgCrop>
                )}
              </Form.Item>

              {/* แสดง Progress bar เมื่อมีการอัปโหลดและยังไม่เสร็จสิ้น */}
              {uploadProgress > 0 && uploadProgress < 100 && !onHiden && (
                <div style={{ padding: "0 0 20px 0" }}>
                  <Progress percent={uploadProgress} />
                </div>
              )}
              {showCropNote && (
                <Alert
                  message={t("คำแนะนำ")}
                  description={t(`ในกรณีที่การตรวจสอบไม่สำเร็จ หรือ รูปภาพสลิปมีขนาดใหญ่กว่า MB โปรดลองใหม่อีกครั้ง โดยจะมีฟังก์ชัน Crop เพื่อตัดเฉพาะส่วน **QR Code** ของสลิปเท่านั้น`, {ms_mb: MAX_SIZE_MB})}
                  type="info"
                  showIcon
                  className="mt-3 mb-3"
                />
              )}
            </Form>
          </Spin>
        </div>
      </>
    );
  }
}

export default ComponentVerifySlip;
